import { Txt } from 'components/Txt';
import { theme } from 'lib/theme';
import * as React from 'react';
import { Pressable, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { appStoreUrlApple, appStoreUrlGoogle, openUrl } from 'lib/riskbase';
import { LogoAppStoreApple } from 'components/LogoAppStoreApple';
import { LogoAppStoreGoogle } from 'components/LogoAppStoreGoogle';
import { ViewWithSeparators } from 'components/ViewWithSeparators';

export const NativeBanner: React.FC = () => {
  const { bottom, left, right } = useSafeAreaInsets();
  const [widthSize, setWidthSize] = React.useState<
    'small' | 'medium' | 'large'
  >('small');

  const isSmall = widthSize === 'small';
  const isMedium = widthSize === 'medium';

  return (
    <View
      style={{
        position: 'absolute',
        bottom: bottom + theme.paddingHorizontal * 2,
        left: left + theme.paddingHorizontal * 2,
        right: right + theme.paddingHorizontal * 2,
        flexDirection: 'column',
      }}
      onLayout={(event) => {
        if (event.nativeEvent.layout.width < 500) {
          setWidthSize('small');
        } else if (event.nativeEvent.layout.width < 650) {
          setWidthSize('medium');
        } else {
          setWidthSize('large');
        }
      }}
    >
      <View
        style={{
          flexDirection: isMedium || isSmall ? 'column' : 'row',
          alignSelf: 'center',
          alignItems: 'center',
          backgroundColor: theme.colors.white50,
          padding: theme.paddingHorizontal,
          borderRadius: 8,
          shadowColor: 'black',
          shadowOffset: { width: 0, height: 0 },
          shadowOpacity: 0.1,
          shadowRadius: 20,
        }}
      >
        <Txt
          size="xsmall"
          weight="medium"
          style={{
            flex: 1,
            textAlign: isSmall ? 'center' : 'left',
            marginBottom:
              isMedium || isSmall ? theme.paddingHorizontal : undefined,
          }}
        >
          {`RiskBase is available on${isSmall ? '\n' : ' '}iOS and Android`}
        </Txt>
        <View style={{ width: theme.paddingHorizontal }} />
        <ViewWithSeparators
          horizontal={!isSmall}
          separatorMargin={theme.paddingHorizontalHalf}
          separatorColor="transparent"
        >
          <Pressable
            onPress={() => openUrl(appStoreUrlApple)}
            accessibilityHint="Opens RiskBase in the Apple App Store"
            style={{
              backgroundColor: 'black',
              borderRadius: 4,
              width: 140,
              alignItems: 'center',
            }}
          >
            <LogoAppStoreApple height={40} />
          </Pressable>
          <Pressable
            onPress={() => openUrl(appStoreUrlGoogle)}
            accessibilityHint="Opens RiskBase in the Google Play Store"
            style={{
              backgroundColor: 'black',
              borderRadius: 4,
              width: 140,
              alignItems: 'center',
            }}
          >
            <LogoAppStoreGoogle height={40} />
          </Pressable>
        </ViewWithSeparators>
      </View>
    </View>
  );
};
